/**
 * Payment methods as the server's admin switches name them. The organization checkout and the
 * learner portal read the same list, so each method is one button everywhere.
 * `card` is a manual transfer to the platform's card, confirmed by an admin; the rest open a provider page.
 */
export type PaymentMethod = 'payme' | 'click' | 'uzum' | 'uzcard' | 'humo' | 'visa_mc' | 'card';
export type OnlinePaymentMethod = Exclude<PaymentMethod, 'card'>;

export const isOnlineMethod = (method: PaymentMethod): method is OnlinePaymentMethod => method !== 'card';

/** Keeps the customer's choice while it is still offered, else the first offered method. */
export function pickPaymentMethod<T extends PaymentMethod>(offered: readonly T[], chosen: T | null): T | null {
  return chosen && offered.includes(chosen) ? chosen : offered[0] ?? null;
}

/** Where customers send the receipt of a card transfer. */
export const PAYMENT_SUPPORT_TELEGRAM = 'https://t.me/yoqub_sobirjonov';
